import { Tabs, TabsContent, TabsList, TabsTrigger } from '@talentmesh/ui/components/tabs';
import { useState } from 'react';
import { useAiSearchProfilePopoutContext } from '../../AiSearchProfilePopoutContext';
import ProfileEmailThread from './ProfileEmailThread/ProfileEmailThread';
import ProfileScore from './ProfileScore';
import UIStrings from '@/Utils/UIStrings';

const ProfileExtra = () => {
    const { hideEmailThreads } = useAiSearchProfilePopoutContext();
    const [tab, setTab] = useState(UIStrings.RankingCriteria);

    return (
        <div className="flex min-w-0 flex-1 flex-col gap-2">
            {hideEmailThreads ? (
                <div className="flex flex-col gap-2">
                    <h4 className="text-base font-semibold tracking-tight">{UIStrings.RankingCriteria}</h4>
                    <ProfileScore />
                </div>
            ) : (
                <Tabs value={tab} onValueChange={setTab} className="flex min-h-0 flex-1 flex-col gap-0">
                    <TabsList variant="default" className="w-full rounded-lg">
                        <TabsTrigger className="rounded-md" value={UIStrings.RankingCriteria}>
                            {UIStrings.RankingCriteria}
                        </TabsTrigger>
                        <TabsTrigger className="rounded-md" value={UIStrings.Email}>
                            {UIStrings.Email}
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent
                        value={UIStrings.RankingCriteria}
                        className="mt-3 flex min-h-0 flex-1 flex-col outline-none"
                    >
                        <ProfileScore />
                    </TabsContent>
                    <TabsContent value={UIStrings.Email} className="mt-3 flex min-h-0 flex-1 flex-col outline-none">
                        <ProfileEmailThread />
                    </TabsContent>
                </Tabs>
            )}
        </div>
    );
};

export default ProfileExtra;
